import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App3 from "./App3.js";

ReactDOM.render(
  <React.StrictMode>
    <App3 />
  </React.StrictMode>,
  document.getElementById("root")
);
